import { Link } from "react-router-dom";
import {useEffect, useState} from "react";
import AddToFavorites from "@/components/hero/hero-1/AddToFavorites.jsx";
import cdnImageUrl from "@/utils/cdnImageUrl.js";

const Blog = ({tripsToShow = 4}) => {
  const [trips, setTrips] = useState([]);
    useEffect(() => {
        fetch('https://api.tripsi.pl/api/trips/best')
            .then(response => response.json())
            .then(data => {
                const dealRate = item => {
                    const current = Number(item.pricePerDay);
                    const usual = Number(item.averagePricePerDay);
                    return usual > 0 && current >= 0 ? (usual - current) / usual : 0;
                };
                setTrips([...data].sort((a, b) => dealRate(b) - dealRate(a)));

            });
    }, []);


  function getTripDate(item) {
    const [startYear, startMonth, startDay] = item.startDate;
    const [endYear, endMonth, endDay] = item.endDate;
    const startDate = new Date(startYear, startMonth - 1, startDay);
    const endDate = new Date(endYear, endMonth - 1, endDay);
    return <>{endDate.toLocaleDateString('pl-PL')} - {startDate.toLocaleDateString('pl-PL')}</>;
  }

  function getBlogTripTitle(item) {
    const duration = item.durationInDays || "";
    const destination = item.destinationData?.inName || item.destinationData?.name || item.destination?.inName || item.destination?.name || "wybranym mieście";
    return <>{duration} dni w {destination} za {Math.round(item.pricePerPerson)} zł za osobę</>;
  }

  if(trips === undefined || trips.length === 0) {
    return <></>;
  }

  return (
    <>
      {trips.slice(0,tripsToShow).map((item) => (
        <div
            className="col-lg-6"
            key={item.id}
            data-aos="fade-up"
            data-aos-delay={item.delayAnimation}
        >
          <Link
              to={`/tour-single/${item.id}`}
              className="row y-gap-20 items-center"
          >
            <div className="col-auto">
              {/* destinationData.photoUrl is "" (not undefined/null) for destinations outside the
                  curated CMS list, common for flight-only results - see TourProperties.jsx's
                  getImageWrapper() for the same fallback. */}
              {item.destinationData?.photoUrl ? (
                <img className="size-250 rounded-4" src={cdnImageUrl(item.destinationData.photoUrl, 400, 400)} srcSet={`${cdnImageUrl(item.destinationData.photoUrl, 280, 280)} 280w, ${cdnImageUrl(item.destinationData.photoUrl, 500, 500)} 500w`} sizes="250px" width="250" height="250" alt={`Widok: ${item.destinationData?.name || "cel podróży"}`} loading="lazy" decoding="async"/>
              ) : (
                <div
                    className="size-250 rounded-4 d-flex items-center justify-center"
                    style={{background: "linear-gradient(135deg, var(--color-dark-1), var(--color-blue-1))"}}
                >
                  <div className="icon-airplane text-40 text-white"></div>
                </div>
              )}
              <AddToFavorites tripId={item.id} />
            </div>
            <div className="col">
              <div className="text-15 text-light-1">{getTripDate(item)}</div>
              {/* h3, not h4 - this section (id="inspire") follows the page's h2 "Zainspiruj
                  się..." title directly, so h4 would skip a level. */}
              <h3 className="text-22 fw-600 text-dark-1 mt-10">{getBlogTripTitle(item)}</h3>
              <p className="mt-10 text-15">
                <strong>{Math.round(item.pricePerDay)} zł / dzień</strong><br/>
                <span className="text-light-1">Zwykle {Math.round(item.averagePricePerDay)} zł · </span>
                <strong className="text-green-2">{Math.round((item.pricePerDay - item.averagePricePerDay)/item.averagePricePerDay * -100)}% taniej</strong>
              </p>
            </div>
          </Link>
        </div>
      ))}
    </>
  );
};

export default Blog;
